import { render, staticRenderFns } from "./TheTinyInput.vue?vue&type=template&id=1fddabf4&scoped=true&"
import script from "./TheTinyInput.vue?vue&type=script&lang=js&"
export * from "./TheTinyInput.vue?vue&type=script&lang=js&"
import style0 from "./TheTinyInput.vue?vue&type=style&index=0&id=1fddabf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fddabf4",
  null
  
)

export default component.exports